module.exports = {
  "metadata": {
    "width": "22",
    "height": "24",
    "name": "check-circle"
  },
  "source": "<path d=\"M18.33 4.67A10.36 10.36 0 1 0 3.67 19.33 10.36 10.36 0 0 0 18.33 4.67zm-2.18 5.58l-4.87 5.21a1 1 0 0 1-.72.32 1 1 0 0 1-.72-.31l-2.68-2.78a1 1 0 1 1 1.44-1.38l1.93 2 4.15-4.44a1 1 0 0 1 1.46 1.37z\"/>"
};